import type { FetchThemePageProps } from '~/types/themePage';

import { useThemePageStore } from '~/stores/themePage';
import { ProviderSource } from '~/types/template';
import { parseTemplateIdBy } from '~/utils';
import { useMemo } from 'react';

export const useTemplateIdV6Parser = (props?: FetchThemePageProps) => {
  const themePageIdsFetched = useThemePageStore((state) => state.idsFetched);

  const variants = useMemo(() => {
    return props?.campaigns?.flatMap((campaign) => campaign.variants) || [];
  }, [props?.campaigns]);

  const parseAndPushTemplateId = (templateSuffix: string | undefined, acc: string[]) => {
    if (!templateSuffix) return;

    const templateId = parseTemplateIdBy(templateSuffix, ProviderSource.GEMPAGESV6);
    const isFetched = templateId && themePageIdsFetched?.includes(templateId);
    if (templateId && !isFetched) {
      acc.push(templateId);
    }
  };

  const templateIdV6WithAsset = useMemo(() => {
    return (
      props?.assets?.templateGPV6?.reduce<string[]>((acc, asset) => {
        parseAndPushTemplateId(asset.key!, acc);
        return acc;
      }, []) || []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.assets?.templateGPV6]);

  const templateIdV6WithVariant = useMemo(() => {
    return (
      variants?.reduce<string[]>((acc, variant) => {
        parseAndPushTemplateId(variant?.templateSuffix, acc);
        return acc;
      }, []) || []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variants]);

  return {
    templateIdV6WithVariant,
    templateIdV6WithAsset,
  };
};
